// JobQ accounts that are programs, not people: "Auto-Ship System" (the nightly AutoShip_BadIdea run) and
// "IoT System" (the shop sensors). The rule is the API's: jobq-api security_presence.SYSTEM_USER_NAMES, which keeps
// their punches from meaning someone is at the shop. Here it keeps them out of every "pick a person" list (the
// Shipping hub's driver pickers: Load truck, Ship by job). The User Management page still lists them, so an admin
// can see and edit them. A new service account named "... System" is caught by the suffix rule as well.
export const SYSTEM_USER_NAMES = Object.freeze(['auto-ship system', 'iot system']);

/** True for a program's account (by name, any case; or a name ending in " System"). */
export function isSystemUser(u) {
  const name = String((u && u.name) || '').trim().toLowerCase();
  if (!name) return false;
  return SYSTEM_USER_NAMES.includes(name) || /\ssystem$/.test(name);
}
